import MainStore from '../../stores/MainStore.js';

export const getFromGraphQL = (callback=null) => {
  var query = `query MetaFields{
    shop {
      discounts: metafield(namespace: "app", key: "discounts"){
        key
        value
      }
    }
  }`;

  var variables = {
    //"id": "gid://shopify/Product/"+id
  };

  fetch(window.__config_reactjs_cart.api_url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.__config_reactjs_cart.api_access_token,
    },
    body: JSON.stringify({ query: query, variables: variables })
  }).then(res => res.json())
    .then((result) => {
      //console.log(result);
      //MainStore.product_graphQL = result.data.product;
      window.__discounts = JSON.parse(result.data.shop.discounts.value);
      //console.log(window.__discounts);
      //console.log(MainStore.product_graphQL);
      if( callback!==null ) callback();
    },
    // Note: it's important to handle errors here
    // instead of a catch() block so that we don't swallow
    // exceptions from actual bugs in components.
    (error) => {
      console.log(error);
      //MainStore.ItemChanged();
    }
  );
}

export const getProducts = (callback=null) => {
  let productIds = [];
  for(let key in window.__cart.items){
    let item = window.__cart.items[key];
    productIds.push("gid://shopify/Product/"+item.product_id);
  }

  
  const query = `
    query GetProductsByIds($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          handle
          compareAtPriceRange{
            maxVariantPrice{
              amount
              currencyCode
            }
            minVariantPrice{
              amount
              currencyCode
            }
          }
          variants(first: 128){
            edges{
              node{
                id
                availableForSale
                quantityAvailable
                price{
                  amount
                  currencyCode
                }
                compareAtPrice{
                  amount
                  currencyCode
                }
                title
              }
            }
          }
          config: metafield(namespace: "pdp", key: "config"){
            key
            value
          }
          # Add more fields as needed
        }
      }
    }
  `;

  //return;
  fetch(window.__config_reactjs_cart.api_url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.__config_reactjs_cart.api_access_token,
    },
    body: JSON.stringify({ query: query, variables: { ids: productIds } })
  }).then(res => res.json())
    .then((result) => {
      window.__config_reactjs_cart.products_config = {};
      window.__config_reactjs_cart.products = {};
      for(let key in result.data.nodes){
        let item = result.data.nodes[key];
        let id = item.id.replace("gid://shopify/Product/","");
        window.__config_reactjs_cart.products[id] = {...item};
        if( item.config!==null ) window.__config_reactjs_cart.products_config[id] = JSON.parse(item.config.value);
      }
      //console.log(window.__config_reactjs_cart.products_config);
      
      if( callback!==null ) callback();
    },
    // Note: it's important to handle errors here
    // instead of a catch() block so that we don't swallow
    // exceptions from actual bugs in components.
    (error) => {
      console.log(error);
      //MainStore.ItemChanged();
    }
  );
}

export const getVariantMetaField = (vid,key) =>{
  let variant = getVariant(vid);
  //console.log(variant);
  if( variant===null ) return null;

  let metafield = variant?.[key]??null;
  if( metafield===null ) return null;
  return metafield["value"];
}

export const getCarouselImages = () =>{
  if( MainStore.product_graphQL===null ) return [];
  return MainStore.product_graphQL.images.edges;
}

export const getCarouselIndexByVariantID = (vid) =>{
  if( MainStore.product_graphQL===null ) return null;
  let image_of_variant = null;
  for( let key in MainStore.product_graphQL.variants.edges ){
    let variant = MainStore.product_graphQL.variants.edges[key].node;
    if( variant.id===("gid://shopify/ProductVariant/"+vid) ){
      image_of_variant = variant.image;
      break;
    }
  }
  if( image_of_variant===null ) return null;

  for( let key in MainStore.product_graphQL.images.edges ){
    let image = MainStore.product_graphQL.images.edges[key].node;
    if( image.id===image_of_variant.id ){
      return key;
    }
  }
  return null;
}

export const getVariant = (vid) =>{
  if( MainStore.product_graphQL===null ) return null;
  for( let key in MainStore.product_graphQL.variants.edges ){
    let variant = MainStore.product_graphQL.variants.edges[key];
    if( variant.node.id===("gid://shopify/ProductVariant/"+vid) ){
      return variant.node;
    }
  }
  return null;
}

export const getThumbnailURL = (url,dimension) =>{
  if( url.indexOf(".jpg")>-1 ) url = url.replace(".jpg","_"+dimension+"x.jpg");
  else if( url.indexOf(".png")>-1 ) url = url.replace(".png","_"+dimension+"x.png");
  else if( url.indexOf(".jpeg")>-1 ) url = url.replace(".jpeg","_"+dimension+"x.jpeg");
  return url;
};

export const getVariantFromVariants = (variants,variant_id) => {
  let variant_return = null;
  for(let key in variants){
    let variant = variants[key];
    if( variant.id===variant_id ){
      variant_return = variant;
      //variant_title = variant.title;
    }
  }
  return variant_return;
}